<template>
  <div class="chemical">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  还原化学-->
    <div class="item" v-show="status === 6">
      <div :class="['title', status === 6 ? 'animated fadeInUp' : '']">
        <div class="big">还原化学</div>
        <div class="small">还物质之源，观变化之学</div>
      </div>
      <div :class="['con', status === 6 ? 'animated fadeInUp' : '']">
        还原化学秉持“追本溯源，融会贯通”的理念，将抽象的化学知识与生活现象有机结合，为学生建造一所充满乐趣和生气的知识殿堂。还原化学本身之美，培养学生对自然科学的学习兴趣。加强求真务实的学习态度，真正让学生用化学知识，解释生活里的一切变化，做到学以致用，更好的生活！
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"]
};
</script>
<style lang="less">
.chemical {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/chemical.jpg) center no-repeat;
  position: relative;
  background-size: cover;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
